export default __webpack_public_path__ + "static/media/5.d6b361ff.svg";